import { z } from "zod";

export const contactUsDialogSchema = (t: (key: string) => string) =>
  z.object({
    firstName: z
      .string()
      .trim()
      .min(1, { message: t("validation.firstNameRequired") })
      .min(2, { message: t("validation.firstNameMin") })
      .max(100, { message: t("validation.firstNameMax") }),
    lastName: z
      .string()
      .trim()
      .min(1, { message: t("validation.lastNameRequired") })
      .min(2, { message: t("validation.lastNameMin") })
      .max(100, { message: t("validation.lastNameMax") }),
    email: z
      .string()
      .trim()
      .min(1, { message: t("validation.emailRequired") })
      .email({ message: t("validation.invalidEmail") }),
    message: z
      .string()
      .trim()
      .min(1, { message: t("validation.messageRequired") }),
  });
